// Angular base libraries
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiPhysicalStoreServiceInterface, ApiPhysicalStore, ApiPhysicalStoreDetail, ApiPhysicalStoreByCountry } from './models/api-physical-store.models';

import { HttpRequestsService, RequestParams } from '@core/infrastructure/http-requests/http-requests.service';

/**
 * Servicio para la interacción de tiendas de store locator con la API
 */
@Injectable()
export class ApiPhysicalStoreService implements ApiPhysicalStoreServiceInterface {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
    ) {}

    /**
     * Llamada a la API para obtener un listado de tiendas
     *
     * @param customParams Parámetros de consulta
     *
     * @return Listado de tiendas
     */
    public getStores(customParams: RequestParams, storeId: string): Observable<ApiPhysicalStore> {
        // Define la Url base de la consulta
        const url = this.requestService.requestUrl(`bam/store/${storeId}/physical-store`, null, customParams, true);

        return this.http.get<ApiPhysicalStore>(url);
    }

    /**
     * Llamada a la API para obtener un listado de tiendas por país
     *
     * @param customParams Parámetros de consulta
     *
     * @return Listado de tiendas
     */
    public getPhysicalStoresByCountry(customParams: RequestParams, storeId: string): Observable<ApiPhysicalStoreByCountry> {
        const url = this.requestService.requestUrl(`bam/store/${storeId}/physical-stores-by-country`, null, customParams);

        return this.http.get<any>(url);
    }

    /**
     * Llamada a la API para obtener una única tienda por ID
     * @param storeId
     * @param languageId
     * @param physicalStoreId
     * @return Physical Store Detail
     */
    public getStore(storeId: string, languageId: string, physicalStoreId: string): Observable<ApiPhysicalStoreDetail> {
        const url = this.requestService.requestUrl(`bam/store/${storeId}/physical-store/${physicalStoreId}`, languageId);

        return this.http.get<ApiPhysicalStoreDetail>(url);
    }
}
